import {createClient} from "./Client";
import DateUtil from "./../util/DateUtil";

export class Task {
    constructor({ id = null, title = '', description = '', due_date = new Date(), taskable_type = '', taskable_id = null,
                    duration = '00:15:00', concluded = 0, user_ids = [], users = [], deal = null, updated_at='', created_at = '', end = null, guests=[], type_id = null } = {}) {

        this.id = id;
        this.title = title;
        this.description = description;
        this.due_date = due_date instanceof Date ? due_date : DateUtil.fromUTC(due_date);
        this.due_date_basic = due_date;
        this.taskable_type = taskable_type;
        this.taskable_id = taskable_id;
        this.duration = duration;
        this.concluded = concluded;
        this.user_ids = !!user_ids && user_ids.length>0 ? user_ids : users.map(user=>user.id);
        this.users = users;
        this.deal = deal;
        this.updated_at = updated_at;
        this.created_at = created_at;
        this.end = end;
        this.guests=guests;
        this.type_id=type_id;
        
    }

    get status(){
        let taskStatus;
        let now = window.moment();

        if (this.concluded === 0) {
            if (window.moment(now).isAfter(window.moment(this.due_date))) {
                taskStatus = 1;
            } else if (window.moment(now).isSame(window.moment(this.due_date), 'day')) {
                taskStatus = 2;
            } else {
                taskStatus = 3;
            }
        } else {
            taskStatus = 0;
        }

        return taskStatus;
    }

    get status_label(){
        switch (this.status){
            case 0:
                return "Concluída";
            case 1:
                return "Atrasada";
            case 2:
                return "Hoje";
            default:
                return "Planejada";
        }
    }

    hasDeal(){
        return this.taskable_type === "App\\Models\\Deal"
    }

    get task_client(){
        let client;
        if (this.deal) {
            client = this.deal.client;
        } else {
            client = this.client;
        }
        return createClient(client || {})
    }

    get duration_date(){
        return new Date("1970-01-01 " + this.duration)
    }

    set duration_date(value){
        this.duration=value.getHours()+":"+value.getMinutes()+":"+value.getSeconds()
    }

    isDeal(){
        return this.taskable_type === "App\\Models\\Deal";
    }

    isClient(){
        return this.taskable_type === "App\\Models\\Client";
    }

    isArchitect(){
        return this.taskable_type === "App\\Models\\Architect";
    }

    setDeal(dealId){
        this.taskable_type = "App\\Models\\Deal";
        this.taskable_id = dealId;
    }

    setClient(clientId){
        this.taskable_type = "App\\Models\\Client";
        this.taskable_id = clientId;
    }

    setArchitect(architectId){
        this.taskable_type = "App\\Models\\Architect";
        this.taskable_id = architectId;
    }

    setCompany(companyId){
        this.taskable_type = "App\\Models\\Company";
        this.taskable_id = companyId;
    }

}

export function createTask(data={}) {
    return Object.freeze(new Task(data));
}